/* ISAMOR · preparación informativa hoy + tránsito calculado desde hoy en días hábiles. */
const DELIVERY_RUNTIME_VERSION = '2026-08-21-today-transit';
const existingDeliveryRuntime = window.ISAMORDeliveryEstimate;

if (existingDeliveryRuntime?.version === DELIVERY_RUNTIME_VERSION) {
  existingDeliveryRuntime.initAll(document);
} else {
  const TZ = 'America/Mexico_City';
  const EXTRA_HOLIDAYS = new Set([]);
  const METHOD_SELECTOR = 'input[type="radio"][data-isamor-delivery-method]';
  const DELIVERY_NOTE = 'Los tiempos de tránsito de la paquetería se contabilizan únicamente en días hábiles; no incluyen sábados, domingos ni días de descanso obligatorio en México. El método de envío definitivo se confirma en checkout.';

  const parts = (d = new Date()) => Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(d).filter((p) => p.type !== 'literal').map((p) => [p.type, p.value])
  );
  const dateUTC = (p) => new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
  const fmt = (d) => new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
  const fmtDay = (d) => new Intl.DateTimeFormat('es-MX', { day: 'numeric', timeZone: 'UTC' }).format(d);
  const iso = (d) => [d.getUTCFullYear(), String(d.getUTCMonth() + 1).padStart(2, '0'), String(d.getUTCDate()).padStart(2, '0')].join('-');
  const same = (a, b) => a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  const sameMonth = (a, b) => a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth();
  const nth = (y, m, w, n) => {
    const f = new Date(Date.UTC(y, m, 1));
    const delta = (w - f.getUTCDay() + 7) % 7;
    return new Date(Date.UTC(y, m, 1 + delta + (n - 1) * 7));
  };
  const holiday = (d) => {
    const y = d.getUTCFullYear(), m = d.getUTCMonth(), day = d.getUTCDate();
    if (EXTRA_HOLIDAYS.has(iso(d))) return true;
    if ((m === 0 && day === 1) || (m === 4 && day === 1) || (m === 8 && day === 16) || (m === 11 && day === 25)) return true;
    if (same(d, nth(y, 1, 1, 1)) || same(d, nth(y, 2, 1, 3)) || same(d, nth(y, 10, 1, 3))) return true;
    return y >= 2024 && (y - 2024) % 6 === 0 && m === 9 && day === 1;
  };
  const business = (d) => {
    const w = d.getUTCDay();
    return w !== 0 && w !== 6 && !holiday(d);
  };
  const addBusiness = (d, n) => {
    const x = new Date(d);
    let c = 0;
    while (c < n) {
      x.setUTCDate(x.getUTCDate() + 1);
      if (business(x)) c++;
    }
    return x;
  };
  const range = (r) => {
    const a = parseInt((r && r.dataset.minDays) || '1', 10);
    const b = parseInt((r && r.dataset.maxDays) || String(a), 10);
    const x = Number.isFinite(a) ? Math.max(1, a) : 1;
    const y = Number.isFinite(b) ? Math.max(1, b) : x;
    return { min: Math.min(x, y), max: Math.max(x, y) };
  };
  const rangeLabel = ({ min, max }) => {
    if (min === max) return `${min} ${min === 1 ? 'día hábil' : 'días hábiles'}`;
    return `${min}–${max} días hábiles`;
  };
  const arrivalLabel = (minDate, maxDate) => {
    if (same(minDate, maxDate)) return fmt(minDate);
    if (sameMonth(minDate, maxDate)) return `${fmtDay(minDate)}–${fmt(maxDate)}`;
    return `${fmt(minDate)}–${fmt(maxDate)}`;
  };
  const messageLabel = (minDate, maxDate) => {
    if (same(minDate, maxDate)) return `Si compras hoy, tu pedido podría llegar el ${fmt(minDate)}.`;
    if (sameMonth(minDate, maxDate)) return `Si compras hoy, tu pedido podría llegar entre el ${fmtDay(minDate)} y el ${fmt(maxDate)}.`;
    return `Si compras hoy, tu pedido podría llegar entre el ${fmt(minDate)} y el ${fmt(maxDate)}.`;
  };

  function init(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.closest('.quick-add-modal')) return;

    const msg = root.querySelector('[data-delivery-message]');
    const order = root.querySelector('[data-order-date]');
    const readyEl = root.querySelector('[data-ready-date]');
    const arrival = root.querySelector('[data-arrival-date]');
    const prepLabel = readyEl?.closest('.isamor-delivery__step')?.querySelector('strong');
    const note = root.querySelector('.isamor-delivery__note');
    const getRadios = () => [...root.querySelectorAll(METHOD_SELECTOR)];
    if (!msg || !order || !readyEl || !arrival || !getRadios().length) return;

    if (
      root.dataset.isamorDeliveryVersion === DELIVERY_RUNTIME_VERSION &&
      typeof root.isamorDeliveryRender === 'function'
    ) {
      root.isamorDeliveryRender();
      return;
    }

    root.dataset.isamorDeliveryReady = 'true';
    root.dataset.isamorDeliveryVersion = DELIVERY_RUNTIME_VERSION;
    root.dataset.ready = 'true';

    function render() {
      const radios = getRadios();
      if (!radios.length) return;

      root.style.setProperty('--isamor-delivery-method-count', String(radios.length));

      radios.forEach((radio) => {
        const label = radio.closest('.isamor-delivery__method')?.querySelector('small');
        if (label) label.textContent = rangeLabel(range(radio));
      });

      const base = dateUTC(parts());
      const selected = radios.find((radio) => radio.checked) || radios[0];
      if (!selected.checked) selected.checked = true;
      const method = range(selected);
      const amin = addBusiness(base, method.min);
      const amax = addBusiness(base, method.max);

      order.textContent = fmt(base);
      if (prepLabel) prepLabel.textContent = 'Preparación';
      readyEl.textContent = 'Hoy';
      arrival.textContent = arrivalLabel(amin, amax);
      msg.textContent = messageLabel(amin, amax);
      if (note) note.textContent = DELIVERY_NOTE;
      root.dataset.state = 'ready';
    }

    root.isamorDeliveryRender = render;
    root.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches(METHOD_SELECTOR)) render();
    });
    render();

    const timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer);
        return;
      }
      render();
    }, 60000);
  }

  function initAll(scope = document) {
    if (scope instanceof Element && scope.matches('[data-isamor-delivery]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-isamor-delivery]').forEach(init);
  }

  function refresh(scope = document) {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-isamor-delivery]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-isamor-delivery]'));

    [...new Set(roots)].forEach((root) => {
      if (root.dataset.isamorDeliveryVersion === DELIVERY_RUNTIME_VERSION && typeof root.isamorDeliveryRender === 'function') {
        root.isamorDeliveryRender();
      } else {
        init(root);
      }
    });
  }

  window.ISAMORDeliveryEstimate = { version: DELIVERY_RUNTIME_VERSION, init, initAll, refresh };
  initAll(document);

  document.addEventListener('shopify:product:select', (event) => {
    if (!event.promise || typeof event.promise.then !== 'function') return;

    event.promise
      .then(() => initAll(document))
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[ISAMOR delivery] No se pudo refrescar tras cambiar producto/variante.', error);
        }
      });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target instanceof Element ? event.target : document);
  });
}
